import React from 'react';

import Loading from '../../Loading';
import useRadarData from './useRadarData';
import RadarView from './RadarView';

const RadarContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData } = useRadarData({
    chartDefinition,
    chartRef,
  });

  if (!options && !isNoData) {
    return <Loading />;
  }

  return (
    <RadarView
      chartRef={chartRef}
      options={options ?? {}}
      isNoData={isNoData || !options}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default RadarContent;
